import { render, staticRenderFns } from "./InstanceNoData.vue?vue&type=template&id=06be1cb3&scoped=true"
import script from "./InstanceNoData.vue?vue&type=script&lang=js"
export * from "./InstanceNoData.vue?vue&type=script&lang=js"
import style0 from "./InstanceNoData.vue?vue&type=style&index=0&id=06be1cb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06be1cb3",
  null
  
)

export default component.exports